import React, { useState, useEffect, useRef } from "react";
import "../../App.css";

function QuickLinksSection({ handleNavClick, links }) {
  return (
    <section className="quick-links-section">
      <div className="section__container">
        <h3 className="quick-links-header">Explore Other Products</h3>
        <div className="quick-links-grid">
          {links.map(link => (
            <div
              key={link.id}
              className={`quick-link-card ${link.bgClass || ''}`}
              onClick={(e) => {
                handleNavClick(link.id);
              }}
            >
              {link.icon && (
                <div className="quick-link-icon">
                  {typeof link.icon === 'string' && (link.icon.endsWith('.png') || link.icon.endsWith('.jpg') || link.icon.endsWith('.jpeg') || link.icon.endsWith('.svg')) ? (
                    <img src={link.icon} alt={link.title} className="quick-link-icon-image1" />
                  ) : (
                    link.icon
                  )}
                </div>
              )}
              <h4 className="quick-link-title">{link.title}</h4>
              <div className="quick-link-arrow">→</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default QuickLinksSection;